/*
 * @Author: qian.tang
 * @Date: 2022-12-20 10:12:11
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2022-12-20 10:43:37
 * @FilePath: \itrazo-portal-dev\src\utilities\ADIApi.ts
 * @Description: adi project apis configuration file
 *
 * Copyright (c) 2022 by Qian Tang qian@itrazotracetech.com, All Rights Reserved.
 */

import axios from "axios";
import { ENCRYPTION_KEY, SESSION_STORAGE_KEYS } from "./CONSTANTS";
import CryptoJS from "crypto-js";
import {
  decryptData,
  getSessionStorage,
} from "./Functions/GlobalHelperFunctions";

/* ----------- value chain module api base configuration ----------------- */
export const VALUE_CHAIN_API = axios.create({
  baseURL: process.env.REACT_APP_VALUE_CHAIN_API_BASE,
  // "https://staging-valuechain-api.itrazoadi.com/",
  // headers: {
  //   "Access-Control-Allow-Origin": "*",
  // },
});

VALUE_CHAIN_API.interceptors.request.use((config) => {
  const { url } = config;
  // console.log('urlllssl11', url)
  return config;
});

VALUE_CHAIN_API.interceptors.response.use((config) => {
  // console.log('response interceptors', response)
  // const { status } = response.data
  const idToken = getSessionStorage(SESSION_STORAGE_KEYS.IDTOKEN, true);

  // if (idToken) {
  //   const jwtToken = idToken.jwtToken;
  //   config.headers.Authorization = `${jwtToken}`;
  // }
  return config;
});

/* ----------- asset management api base configuration ----------------- */
export const ASSET_MANAGEMENT_API = axios.create({
  baseURL: process.env.REACT_APP_ASSET_MANAGEMENT_API_BASE,
});

ASSET_MANAGEMENT_API.interceptors.request.use((config) => {
  const idToken = getSessionStorage(SESSION_STORAGE_KEYS.IDTOKEN, true);
  if (idToken) {
    const jwtToken = idToken.jwtToken;
    config.headers.Authorization = `${jwtToken}`;
  }
  return config;
});

ASSET_MANAGEMENT_API.interceptors.response.use((response) => {
  // console.log('response interceptors', response)
  // const { status } = response.data

  return response;
});

/* ----------- CRM api base configuration ----------------- */

export const CRM_API = axios.create({
  baseURL: process.env.REACT_APP_CRM_API_BASE,
  headers: {},
});
CRM_API.interceptors.request.use((config) => {
  const idToken = getSessionStorage(SESSION_STORAGE_KEYS.IDTOKEN, true);
  if (idToken) {
    const jwtToken = idToken.jwtToken;
    config.headers.Authorization = `${jwtToken}`;
  }

  return config;
});

// CRM_API.interceptors.request.use((config) => {
//   const { url } = config;
//   // console.log('urlllssl11', url)
//   return config;
// });

// CRM_API.interceptors.response.use((response) => {
//   // console.log('response interceptors', response)
//   // const { status } = response.data

//   return response;
// });

/* ----------- OSM api base configuration ----------------- */
export const OSM_API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE + "osm/",
});

OSM_API.interceptors.request.use((config) => {
  const idToken = getSessionStorage(SESSION_STORAGE_KEYS.IDTOKEN, true);
  if (idToken) {
    const jwtToken = idToken.jwtToken;
    config.headers.Authorization = `${jwtToken}`;
  }

  return config;
});

/* ----------- SITE VISITOR api base configuration ----------------- */
export const SITE_VISITOR_API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE + "sitevisitor/",
});

SITE_VISITOR_API.interceptors.request.use((config) => {
  const idToken = getSessionStorage(SESSION_STORAGE_KEYS.IDTOKEN, true);
  if (idToken) {
    const jwtToken = idToken.jwtToken;
    config.headers.Authorization = `${jwtToken}`;
  }

  return config;
});

/* ------ gs1keys ------ */
export const GS1_KEY_API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE + "itrazo/key-management/",
});

GS1_KEY_API.interceptors.request.use((config) => {
  const idToken = getSessionStorage(SESSION_STORAGE_KEYS.IDTOKEN, true);
  if (idToken) {
    const jwtToken = idToken.jwtToken;
    config.headers.Authorization = `${jwtToken}`;
  }

  return config;
});

/* ----------- ADMIN api base configuration ----------------- */
export const ADMIN_API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE + "itrazo/",
});

ADMIN_API.interceptors.request.use((config) => {
  const idToken = getSessionStorage(SESSION_STORAGE_KEYS.IDTOKEN, true);
  if (idToken) {
    const jwtToken = idToken.jwtToken;
    config.headers.Authorization = `${jwtToken}`;
  }

  return config;
});
export default null;
